import Module from '@/types/user/module'
import { BaseService } from './../../base'
export class ModuleService extends BaseService<Module>() {
    static get entity (): string {
        return 'module'
    }
    static get responseName (): string {
        return 'module'
    }
}